import React from "react";

import {
  cancelAnimationFrame,
  requestAnimationFrame,
} from "@/utils/requestAnimationFrame";

type CounterProps = {
  duration: number;
  start: number;
  end: number;
  children: any;
};

type CounterState = {
  isTweening: boolean;
};

type TweenProps = {
  from: number;
  to: number;
  duration: number;
  children: any;
  onComplete: Function;
};

type TweenState = {
  value: number;
  fromValue?: number;
  currentTime?: number;
  startTime?: number;
};

const easings = {
  cubic: (n: any) => --n * n * n + 1,
};

class TweenNumber extends React.Component<TweenProps, TweenState> {
  private start: any;
  private stop: any;
  private frame: any;

  constructor(props: TweenProps) {
    super(props);
    this.start = null;
    this.stop = null;
    this.state = {
      fromValue: props.from,
      value: props.to,
    };
  }

  public componentDidMount(): void {
    this.start = Date.now();
    this.frame = requestAnimationFrame(this.animate.bind(this));
  }

  public animate(): void {
    if (this.stop) {
      return cancelAnimationFrame(this.frame);
    }
    this.frame = requestAnimationFrame(this.animate.bind(this));
    this.draw();
  }

  public draw(): void {
    const time = this.props.duration;
    const begin = this.props.from;
    const end = this.props.to;
    const now = Date.now();
    if (now - this.start >= time) {
      this.stop = true;
    }
    let percentage = (now - this.start) / time;
    percentage = percentage > 1 ? 1 : percentage;
    const easeVal = easings.cubic(percentage);
    const val = begin + (end - begin) * easeVal;

    this.setState({
      value: Math.round(val),
    });
  }

  public render(): JSX.Element {
    return this.props.children(this.state.value);
  }
}

class Counter extends React.Component<CounterProps, CounterState> {
  constructor(props: CounterProps) {
    super(props);
    this.state = {
      isTweening: true,
    };
  }

  public render(): JSX.Element {
    const { start, end, duration } = this.props;

    if (this.state.isTweening) {
      return (
        <TweenNumber
          {...{ from: start, to: end, duration: duration }}
          onComplete={() => this.setState({ isTweening: false })}
        >
          {(tween: any) => this.props.children(tween)}
        </TweenNumber>
      );
    }

    return <React.Fragment>{this.props.children(end)}</React.Fragment>;
  }
}

export default Counter;
